// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Production project. Used unless overridden — see .env.local.
const DEFAULT_SUPABASE_URL = "https://ordjlndbltcepkplpotv.supabase.co";
const DEFAULT_SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9yZGpsbmRibHRjZXBrcGxwb3R2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYyMDIyMzQsImV4cCI6MjA1MTc3ODIzNH0.43Laac5wPQ1rdiEJ0UU6dMJZuGIZYcc_nRBFjB9U95Q";

// Point a local dev server at the `develop` branch by creating .env.local with
// VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY. Deployed builds have no
// .env.local and therefore keep using production.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? DEFAULT_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY =
  import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? DEFAULT_SUPABASE_PUBLISHABLE_KEY;

if (import.meta.env.DEV && SUPABASE_URL !== DEFAULT_SUPABASE_URL) {
  // Loud on purpose: it should never be ambiguous which database you are hitting.
  console.warn(`[supabase] Using override: ${SUPABASE_URL}`);
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// This must remain the app's ONLY createClient call: a second GoTrueClient
// sharing the same storage key races on refresh-token rotation and revokes
// the session (the "logged out every time" bug).
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
